import {
  SET_LOADING,
  CACHE_UPDATE,
  POPULATE_CONTEXT,
  POPULATE_SCENARIO_DETAILS,
  POPULATE_GRAPH_INTERVAL,
  POPULATE_SEARCHED_CAREERS,
  POPULATE_SCENARIO_LIST,
  SET_OPEN_PANEL,
  POPULATE_SEARCHED_COLLEGES,
  PANELS,
} from './constants';

const initialState = {
  loading: false,
  interval: 'Yearly',
  context: {},
  updates: {},
  searchedCareers: [],
  searchedColleges: [],
  openPanel: null,
  scenario: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case POPULATE_CONTEXT:
      return {
        ...state,
        context: action.context,
      };
    case POPULATE_SCENARIO_DETAILS:
      return {
        ...state,
        scenario: action.scenario,
        openPanel: !action.scenario?.career?.pk
          ? PANELS.CAREER
          : state.openPanel,
        updates: {},
      };
    case POPULATE_GRAPH_INTERVAL:
      return {
        ...state,
        interval: action.interval,
      };
    case POPULATE_SEARCHED_CAREERS:
      return {
        ...state,
        searchedCareers: action.careers,
      };
    case POPULATE_SCENARIO_LIST:
      return {
        ...state,
        scenarioList: action.data,
      };
    case CACHE_UPDATE:
      return {
        ...state,
        updates: {
          ...state.updates,
          ...action.update,
        },
      };
    case SET_OPEN_PANEL:
      return {
        ...state,
        openPanel: action.panel,
      };
    case POPULATE_SEARCHED_COLLEGES:
      return {
        ...state,
        searchedColleges: action.colleges,
      };
    default:
      return state;
  }
};
